import { render, staticRenderFns } from "./RevenueComparison.vue?vue&type=template&id=589ef333"
import script from "./RevenueComparison.vue?vue&type=script&lang=ts"
export * from "./RevenueComparison.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports